<template>
    <div>
        <div class="header" ref="header">
            <div class="header-line" :style="{'padding-top': this.$route.params.NavBarHeight+'px', 'height': ((201 + this.$route.params.NavBarHeight) / 375) * 100% + 'px'}">
                <div>
                    <div id='team-name'>{{ team.teamName }}</div>
                    <div class='sub-title-1'>
                        {{ team.establishTime }}{{ $t("teamIndex.founded") }}/{{ team.country }}&nbsp;-&nbsp;{{ team.city }}
                    </div>
                    <a class='link' @click="clickWebsite()" v-if="team.website">
                      <span>{{ $t("teamIndex.officialWebsite") }}&nbsp;{{ team.website }}</span>
                      <img alt="next" src="~@/assets/football/next.png">
                    </a>
                    <div class="total">
                      <div v-if="team.price > 0" class="totalPrice">
                        <div class="totalContent">{{team.price / 10000}}万{{ priceCurrencyAry[team.priceCurrency] }}</div>
                        <div class="totalTitle">{{ $t("teamIndex.totalPrice") }}</div>
                      </div>
                      <div>
                        <div class="totalContent">{{totalWin}}{{ $t("teamIndex.win") }}{{totalDraw}}{{ $t("teamIndex.draw") }}{{totalLose}}{{ $t("teamIndex.loss") }}</div>
                        <div class="totalTitle">{{ $t("teamIndex.record") }}</div>
                      </div>
                    </div>
                </div>
                <teamLogo id='logo' :teamId='$route.params.teamId.toString()'/>
            </div>
        </div>
        <nav-list :routers="routers">
          <keep-alive>
            <router-view ref="routerView"/>
          </keep-alive>
        </nav-list>

    </div>
</template>

<script>
import NavList from '@/components/NavList.vue'
import teamLogo from '@/components/TeamLogo'
import { scrollHeaderMinxin } from '@/views'

export default {
  name: 'team',
  components: {
    NavList,
    teamLogo
  },
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  mixins: [scrollHeaderMinxin],
  watch: {
    teamId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadTeamInfo()
        this.loadTeamHistory()
      }
    }
  },
  mounted () {
    this.loadTeamInfo()
    this.loadTeamHistory()
  },
  methods: {
    loadTeamInfo: function () {
      this.$ft_getTeamInfo(this.$route.params.teamId).then(result => {
        this.team = result
        this.$refs.routerView.teamInfo = this.team
        this.pageTitle = this.team.teamName
      }).catch((error) => {
        console.log('error:', error)
      })
    },
    loadTeamHistory: function () {
      this.$ft_getTeamHistory(this.$route.params.teamId).then(result => {
        this.previous = result.history
        this.totalWin = 0
        this.totalLose = 0
        this.totalDraw = 0
        this.computeResultWithPrevious()
        this.$refs.routerView.previous = this.previous
      }).catch((error) => {
        console.log('error:', error)
      })
    },
    computeResultWithPrevious: function () {
      this.previous.forEach((item, index) => {
        var currentTeamScore = 0
        var awayScore = 0
        if (parseInt(item.homeTeamId) === parseInt(this.$route.params.teamId)) {
          currentTeamScore = item.homeScore
          awayScore = item.awayScore
        } else {
          currentTeamScore = item.awayScore
          awayScore = item.homeScore
        }
        if (currentTeamScore > awayScore) {
          this.totalWin++
        } else if (awayScore > currentTeamScore) {
          this.totalLose++
        } else {
          this.totalDraw++
        }
      })
    },
    clickWebsite: function () {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        // iOS
        let jsonprc = {
          jsonrpc: 2.0,
          method: 'openCustomScheme',
          params: `${this.team.website}?external_browser=1`
        }
        window.webkit.messageHandlers.nativeCallBack.postMessage(jsonprc)
      } else {
        // Android
        let params = {
          jumpUrl: `${this.team.website}?external_browser=1`
        }
        window.JsPhone.jumpPageUrl(JSON.stringify(params))
      }
    }
  },
  data: function () {
    return {
      team: {},
      previous: [], // 往绩数据
      totalWin: 0,
      totalDraw: 0,
      totalLose: 0,
      priceCurrencyAry: [this.$t('common.euro'), this.$t('common.dollar'), this.$t('common.pound'), this.$t('common.rmb')]
    }
  },
  computed: {
    routers: function () {
      return [
        [this.$t('teamIndex.fixture'), 'football-team-schedule', this.$router.params],
        [this.$t('teamIndex.trackRecord'), 'football-team-previous', { ...this.$router.params, 'previousForRoute': this.previous }],
        [this.$t('teamIndex.stats'), 'football-team-stats', this.$router.params],
        [this.$t('teamIndex.lineUp'), 'football-team-line-up', { ...this.$router.params, 'teamInfoForRoute': this.team }],
        [this.$t('teamIndex.info'), 'football-team-info', { ...this.$router.params, 'teamInfoForRoute': this.team }],
        [this.$t('teamIndex.transfer'), 'football-team-transfer', { ...this.$router.params, 'teamInfoForRoute': this.team }]
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
@import "style"
</style>
